<template>
  <div :class="classes">
    <div v-if="showHead" :class="`${prefixCardClass}-header`">
      <slot name="head"></slot>
    </div>
    <div :class="`${prefixCardClass}-block`">
      <slot></slot>
    </div>
    <div v-if="showFooter" :class="`${prefixCardClass}-footer`">
      <slot name="foot"></slot>
    </div>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_CARD_CLASS = `${PREFIX_CLASS}card`
const DEFAULT_PADDING = 16

export default {
  props: {
    disHover: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: DEFAULT_PADDING
    }
  },
  data() {
    return {
      showHead: true,
      showFooter: true
    }
  },
  computed: {
    prefixCardClass() {
      return PREFIX_CARD_CLASS
    },
    classes() {
      return [
        PREFIX_CARD_CLASS,
        {
          [`${PREFIX_CARD_CLASS}-dis-hover`]: this.disHover
        }
      ]
    }
  },
  mounted() {
    this.showHead = this.$slots.head !== undefined
    this.showFooter = this.$slots.foot !== undefined
  }
}
</script>



// WEBPACK FOOTER //
// card.vue?075fa120